/* @flow */

import type { CombinedReducers } from '../../../../reducers';
import type { BOApi, CommonRequestDetails } from '../types/common';

import { createCustomNetworkErrorFromKey } from '../../../../../libs/netgemLibrary/helpers/CreateCustomNetworkError';
import { buildBOHeaders } from './headers';

const getRequestDetails: (getState: () => CombinedReducers, distributorId: string, apiMethodName: BOApi, extraHeaders?: Array<string>) => CommonRequestDetails = (
  getState,
  distributorId,
  apiMethodName,
  extraHeaders,
) => {
  const {
    appConfiguration,
    netgemApi: {
      distributors: {
        [distributorId]: {
          urls: { [apiMethodName]: urlDefinition },
        },
      },
    },
  } = getState();

  if (!urlDefinition) {
    throw createCustomNetworkErrorFromKey('common.messages.errors.missing_url_definition_for_distributor', {
      distributorId,
      methodName: apiMethodName,
    });
  }

  const { authent, method, uri } = urlDefinition;
  const headers = buildBOHeaders(distributorId, appConfiguration, extraHeaders);

  return {
    authent,
    headers,
    method,
    uri,
  };
};

export default getRequestDetails;
